import { VscLiveShare } from "react-icons/vsc";
import { TbHeart } from "react-icons/tb";
import { SiTarget } from "react-icons/si";

import { ReactComponent as VerifiedBadge } from "../../../assets/images/launchpad/verified-badge.svg";
import { ReactComponent as VerifiedChecker } from "../../../assets/images/launchpad/verified-check.svg";
import { ReactComponent as BinanceCoin } from "../../../assets/images/launchpad/binance-coin.svg";

import { getEllipsisTxt } from "../../../helpers/formatters";

import TokenTimer from "../../UI/TokenTimer";
import {
    getTokenLink,
    // PREMIUM_PARTNERS,
    // PREMIUM_PRESALES,
} from "../../../utils/constants";
import LinkWithSearchParams from "../../UI/LinkWithSearchParams";
// import { getPartnerDetails } from "../../../utils/apis";

import { useValidAccount } from "../../../hooks";

const LaunchPadCard = (props) => {
    const {
        offChainData,
        presaleAddress,
        // audit,
        name,
        // softCap,
        hardCap,
        progress,
        // liquidity,
        lockupTime,
        presaleStartTime,
        presaleEndTime,
        // minCon,
        // maxCon,
        // presaleState,
        status,
        projectStore,
        likeHandler,
    } = props;

    const { account } = useValidAccount();

    return (
        <div className="flex flex-col gap-1 relative">
            <LinkWithSearchParams
                className="relative group"
                to={{
                    pathname: `/presale/${presaleAddress}`,
                }}
            >
                <button className="absolute px-4 bottom-0 group-hover:bottom-4 right-12 opacity-0 duration-150 group-hover:opacity-100 blueGradient-button">
                    <SiTarget className="mr-1" /> View
                </button>
                <img
                    className="card-component aspect-square w-full"
                    src={getTokenLink(offChainData)}
                    alt="ProfilePicture"
                />
            </LinkWithSearchParams>
            <div className="flex items-center gap-2">
                <a
                    href={`https://bscscan.com/address/${presaleAddress}`}
                    target="_blank"
                    rel="noreferrer"
                    className="hover:text-kadGrSt duration-150"
                >
                    {getEllipsisTxt(presaleAddress)}
                </a>
                {(projectStore?.isKYC || !!offChainData?.kycLink) && (
                    <a
                        href={projectStore?.isKYCLink || offChainData?.kycLink}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <VerifiedBadge className="hover:opacity-70 duration-150 w-6" />
                    </a>
                )}
                {(projectStore?.isAudited || !!offChainData?.auditLink) && (
                    <a
                        href={
                            projectStore?.isAuditLink || offChainData?.auditLink
                        }
                        target="_blank"
                        rel="noreferrer"
                    >
                        <VerifiedChecker className="hover:opacity-70 duration-150 w-[1.4rem]" />
                    </a>
                )}
            </div>
            <div className="flex justify-between items-center">
                <span className="size-2 font-bold">{name}</span>
                <span className="flex gap-1">
                    <BinanceCoin />
                    {hardCap} BNB
                </span>
            </div>
            <div className="relative h-4 overflow-hidden rounded-full">
                <span
                    className="absolute z-[2] leading-[14px] text-[12px]"
                    style={{
                        left:
                            (progress * 100) / hardCap > 30
                                ? `${(progress * 100) / hardCap - 15}%`
                                : 5,
                    }}
                >
                    {parseInt((progress * 100) / hardCap)}%
                </span>
                <span className="absolute w-full h-full presale-progress-panel" />
                <span
                    className="absolute h-full presale-progress-bar"
                    style={{ width: `${(progress / hardCap) * 100}%` }}
                />
            </div>
            <div className="flex flex-row items-center z-[2] size-sm">
                <TbHeart
                    className={`size-2 cursor-pointer duration-150 hover:stroke-kadGrSt mr-0.5 ${
                        offChainData?.likes?.includes(account)
                            ? "stroke-kadGrSt fill-kadGrSt"
                            : ""
                    }`}
                    onClick={() => likeHandler && likeHandler(presaleAddress)}
                />
                {offChainData?.likes?.length || "0"}
                <VscLiveShare className="size-2 cursor-pointer duration-150 hover:fill-kadGrSt ml-2 mr-auto" />
                <TokenTimer
                    className="flex flex-col ml-auto items-end"
                    icon={false}
                    status={status}
                    presaleStartTime={presaleStartTime}
                    presaleEndTime={presaleEndTime}
                    lockupTime={lockupTime}
                />
            </div>
        </div>
    );
};
export default LaunchPadCard;
